import React, { useState } from 'react';
import propTypes from 'prop-types';
import {
  Button,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from 'reactstrap';
import { CANCELLED_STATUS } from '../../../../constants/kickavenue';
import { isConfirmPickupDisabled } from '../../../../helpers/saleCursorPagination';
import { resolveMarketplaceLogistics } from '../Helper/MarketplacePickupHelper';
import './MarketplaceRowActions.css';

const BlockedActionModal = ({ isOpen, title, body, onClose }) => (
  <Modal isOpen={isOpen} toggle={onClose} className="modal-dialog modal-md">
    <ModalHeader toggle={onClose}>{title}</ModalHeader>
    <ModalBody>
      <p className="mb-0">{body}</p>
    </ModalBody>
    <ModalFooter>
      <Button color="secondary" onClick={onClose}>Close</Button>
    </ModalFooter>
  </Modal>
);

BlockedActionModal.propTypes = {
  isOpen: propTypes.bool,
  title: propTypes.string.isRequired,
  body: propTypes.string.isRequired,
  onClose: propTypes.func.isRequired,
};

BlockedActionModal.defaultProps = {
  isOpen: false,
};

const MarketplaceRowActions = ({ sale, status, onConfirmPickup, onRelist }) => {
  const [blocked, setBlocked] = useState(null);
  const hasAwb = resolveMarketplaceLogistics(sale).hasAwb;
  const pickupBlocked = isConfirmPickupDisabled({ hasAwb });
  const relistBlocked = status !== CANCELLED_STATUS;
  const invoice = sale && sale.invoice_number ? sale.invoice_number : 'this order';
  const closeBlocked = () => setBlocked(null);

  return (
    <React.Fragment>
      <Button
        color={pickupBlocked ? 'secondary' : 'success'}
        size="sm"
        className={pickupBlocked ? 'marketplace-blocked-btn' : undefined}
        title={pickupBlocked ? 'Waiting for seller-center RTS and the AWB' : 'Confirm Pickup'}
        onClick={pickupBlocked ? () => setBlocked('pickup') : onConfirmPickup}
      >
        <i className="fa fa-truck"></i>
        {' Confirm Pickup'}
      </Button>
      <Button
        color={relistBlocked ? 'secondary' : 'warning'}
        size="sm"
        className={relistBlocked ? 'marketplace-blocked-btn' : undefined}
        title={relistBlocked
          ? 'Waiting for the cancellation webhook'
          : 'Return this unit to the original listing'}
        onClick={relistBlocked ? () => setBlocked('relist') : onRelist}
      >
        Relist
      </Button>
      <BlockedActionModal
        isOpen={blocked === 'pickup'}
        title="Confirm Pickup"
        body={`${invoice} has not been marked ready to ship in the seller center, or the AWB webhook has not been received yet.`}
        onClose={closeBlocked}
      />
      <BlockedActionModal
        isOpen={blocked === 'relist'}
        title="Relist"
        body={`The cancellation webhook for ${invoice} has not been received yet.`}
        onClose={closeBlocked}
      />
    </React.Fragment>
  );
};

MarketplaceRowActions.propTypes = {
  sale: propTypes.object,
  status: propTypes.string,
  onConfirmPickup: propTypes.func.isRequired,
  onRelist: propTypes.func,
};

MarketplaceRowActions.defaultProps = {
  sale: null,
  status: '',
  onRelist: undefined,
};

export default MarketplaceRowActions;
